<script lang="ts" module>
	interface ToastData {
		status: 'success' | 'error';
		message: string;
	}

	const {
		elements: { content, description, close },
		helpers,
		states: { toasts },
		actions: { portal }
	} = createToaster<ToastData>();

	export const addToast = helpers.addToast;
</script>

<script lang="ts">
	import { createToaster, melt } from '@melt-ui/svelte';
	import { AlertCircle, CheckCircle2, X } from 'lucide-svelte';
	import { flip } from 'svelte/animate';
	import { fade } from 'svelte/transition';
</script>

<div
	class="fixed top-0 z-50 flex w-full flex-col gap-2 md:top-auto md:right-0 md:bottom-0 md:m-4 md:w-auto lg:items-end"
	use:portal
>
	{#each $toasts as { id, data } (id)}
		<div
			use:melt={$content(id)}
			animate:flip={{ duration: 500 }}
			transition:fade
			class={`flex items-center justify-between rounded-lg p-4 drop-shadow ${data.status}`}
		>
			{#if data.status === 'success'}
				<CheckCircle2 class="fill-green-primary w-8 text-[#cce8e0]" />
			{:else if data.status === 'error'}
				<AlertCircle class="fill-red-ticker w-8 text-[#f5cfd3]" />
			{/if}
			<div use:melt={$description(id)} class="mx-2">
				{data.message}
			</div>
			<button use:melt={$close(id)} aria-label="close notification">
				<X class="text-gray-mid" />
			</button>
		</div>
	{/each}
</div>

<style lang="postcss">
	@reference '../app.css';

	.success {
		@apply bg-[#cce8e0] p-4;
	}

	.error {
		@apply bg-[#f5cfd3] p-4;
	}
</style>
